import { keepPreviousData, useQuery } from '@tanstack/react-query'
import { useDebounce } from '@uidotdev/usehooks'

import { OrgIndexShape } from '~/app/admin/teams/page'
import { AsyncCommandMenu } from '~/components/command-menu/components/AsyncCommandMenu'
import { useCommandMenu } from '~/components/command-menu/hooks/useCommandMenu'
import { CommandMenuViewType } from '~/components/command-menu/types'
import { QUERY_KEYS } from '~/constants/react-query'
import { useViewAsOrg } from '~/hooks/org'
import { useServerRequests } from '~/hooks/useRequests'

export const SelectAdminTeam = ({ view }: { view: CommandMenuViewType }) => {
  const { searchValue, setActiveView } = useCommandMenu()
  const { serverGetRequest } = useServerRequests()
  const viewAsOrg = useViewAsOrg()
  const debouncedSearch = useDebounce(searchValue, 300)

  const { data, isLoading } = useQuery({
    queryKey: [QUERY_KEYS.ADMIN_ORGS_COMMAND_MENU, debouncedSearch],
    placeholderData: keepPreviousData,
    queryFn: async () => {
      const result = await serverGetRequest<{
        items: OrgIndexShape[]
        rowCount: number
      }>({
        path: '/api/admin/orgs',
        params: {
          searchTerm: debouncedSearch,
          pageSize: 50,
          filters: JSON.stringify([{ id: 'isArchived', value: 'false' }]),
          sorting: JSON.stringify([
            { id: 'cachedTotalValueLocked', desc: true },
          ]),
        },
      })
      return result?.data?.items ?? []
    },
  })

  return (
    <AsyncCommandMenu
      view={view}
      isLoading={isLoading}
      debouncedSearch={debouncedSearch}
      placeholder="Search by workspace name or id..."
      actionLabel="View as workspace"
      emptyMessage="No workspaces found"
      items={(data ?? []).map((org) => ({
        id: org.id,
        label: org.name,
        onSelect: () => {
          viewAsOrg({ orgId: org.id, destinationPath: '/' })
          setActiveView(null)
        },
      }))}
    />
  )
}
